<template>
        <div class="page">
          <div class="culture">
           <!-- <img src="~@/assets/img/home-1.jpg"/>-->
            <div class="culture-title">
              <div>客随衡达</div>
              <div>THE GUESTS ARRIVED WITH ME</div>
            </div>
          </div>
          <div class="culture-img">
            <div>
              <div>CORPORATE CULTURE</div>
              <div>企业文化</div>
              <div>湖南省衡阳汽车运输集团有限公司创建于1950年元月，2000年7月改制为股份有限公司，2004年底通过ISO9001国际质量认证，是衡阳市唯一一家具有国家二级客运
              资质的运输企业。现有在职员工3939名，客货车辆1300余台。集团公司下设22个二级机构，佣有18个客货车队，11个保养场，2个一级客运张，7个二级客运站，40个区乡站，分布于
              衡阳市区及所辖的7个县。客运线路覆盖湖南、湖北、广东、广西、海南、云南、江西、浙江等省区。主要经营汽车客货运输、现代物流、城市公交、出租车、汽车修理、
              货物装卸、汽车燃润油料、汽车配件销售；旅馆、餐饮服务、商业贸易、广告装潢、房地产开发、物业管理、电子商务等。图案中心区由两只腾空而起的大雁组成一个
              “衡”字汉语拼音的声母“H”，寓意着地处雁城的衡汽集团在以董事长为首的领头雁的带领下，团结拼搏，勇往直前。变体的字母“H”又像一条向前延伸的高速公路；
              一个被变体的字母“H”冲破的圆，寓意着衡汽集团在坚持发展运输主业的基础上，积极谋求突破和发展多种经营。图案主体颜色为红色和绿色，红色代表企业红红火火，绿色代表企业生机勃勃和追求绿色环保的企业理念。</div>
            </div>
            <div>
             <!-- <img src="~@/assets/img/home-1.jpg"/>-->
            </div>
          </div>

          <div>
            <div></div>
            <div></div>
          </div>
       </div>
</template>

<script>
    export default {
        name: "info"
    }
</script>

<style scoped>
  .culture{
    width: 100%;
    height: 500px;
  }

  .culture img{
    width: 100%;
    height: 100%;
  }

  .culture-title{
    display: flex;
    flex-direction: column;
    color: white;
    position: relative;
    top: -350px;
  }

  .culture-title > div{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: 150px;
    text-align: start;
  }

  .culture-title > div:nth-child(1){
    font-size: 40px;
    margin-bottom: 20px;
  }

  .culture-title > div:nth-child(2){
    font-size: 27px;
    width: 70%;
  }

  .culture-img{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 100px;
   }
  .culture-img > div{
    flex:1;
  }

  .culture-img > div:nth-child(1){
    text-align: start;
    display: flex;
    justify-items: center;
    align-items: center;
    flex-direction: column;

  }

  .culture-img > div:nth-child(1)>div{
    width: 100%;
    margin: 20px;
  }
  .culture-img > div:nth-child(1)>div:nth-child(1){
     margin-bottom: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/modules/culture.vue